module.exports = __webpack_public_path__ + "img/Logo-mob.0602674b.svg";